import { render, staticRenderFns } from "./SignatureDetails.vue?vue&type=template&id=142dd036&"
import script from "./SignatureDetails.vue?vue&type=script&lang=js&"
export * from "./SignatureDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports